import { createFileRoute } from "@tanstack/react-router";
import PartsCatalogResults from "@/pages/PartsCatalogResults";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/parts-catalog/results")({
  head: () => pageHead({ title: 'Parts Search Results', description: 'Search results for RV parts and accessories at Rex & Sons RVs.', path: '/parts-catalog/results' }),
  component: PartsCatalogResults,
});
